<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-04 10:54:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
  <div :model="model" style="background: #fafafa">
    <div class="weui-cells__title" style="font-weight:bold;font-size:110%;background-color: transparent">这是一份面向鼎信通讯访客的调研问卷，填写大约需要1分钟，诚邀您对本次到访体验进行评价，您的满意是我们不懈的追求，您的参与，将帮助我们更好的提升服务质量。</div>
    <!-- <div class="weui-cells__title" style="font-weight:bold;font-size:110%;background-color: transparent;">入园申请</div> -->
    <!-- <div class="link-top" tyle="width: 50%;height: 1px;border-top: solid #ACC0D8 1px;"></div> -->
    <!-- <div class="weui-cells__title TitleClass" align="center">
      鼎信通讯访客满意度调研
    </div> -->
    <div class="weui-cells__title">1.您来到鼎信通讯园区的原因是？</div>
    <div class="weui-cells weui-cells_radio">
      <label class="weui-cell weui-check__label" for="x11">
        <div class="weui-cell__bd">
          <p>参观园区</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            class="weui-check"
            name="radio1"
            id="x11"
            value="参观园区"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x12">
        <div class="weui-cell__bd">
          <p>供应商来访</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio1"
            class="weui-check"
            id="x12"
            value="供应商来访"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x13">
        <div class="weui-cell__bd">
          <p>参加培训</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio1"
            class="weui-check"
            id="x13"
            value="参加培训"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x14">
        <div class="weui-cell__bd">
          <p>面试</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio1"
            class="weui-check"
            id="x14"
            value="面试"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x15">
        <div class="weui-cell__bd">
          <p>采访、拍摄需要</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio1"
            class="weui-check"
            id="x15"
            value="采访、拍摄需要"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x16">
        <div class="weui-cell__bd">
          <p>工程、维修工作需要</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio1"
            class="weui-check"
            id="x16"
            value="工程、维修工作需要"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label" align="left" style="width=21px"
            >其他:
          </label>
        </div>
        <div class="weui-cell__bd">
          <input
            v-model="reason"
            class="weui-input"
            @change="changeState()"
            type="text"
            placeholder="可填写原因"
          />
        </div>
      </label>
    </div>
    <div class="weui-cells__title">2.您对进入园区的流程是否满意？</div>
    <div class="weui-cells weui-cells_radio">
      <label class="weui-cell weui-check__label" for="x21">
        <div class="weui-cell__bd">
          <p>非常满意</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            class="weui-check"
            name="radio2"
            id="x21"
            value="非常满意"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x22">
        <div class="weui-cell__bd">
          <p>满意</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio2"
            class="weui-check"
            id="x22"
            value="满意"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x23">
        <div class="weui-cell__bd">
          <p>中立</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio2"
            class="weui-check"
            id="x23"
            value="中立"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x24">
        <div class="weui-cell__bd">
          <p>不满意</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio2"
            class="weui-check"
            id="x24"
            value="不满意"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x25">
        <div class="weui-cell__bd">
          <p>非常不满意</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio2"
            class="weui-check"
            @change="disContent()"
            id="x25"
            value="非常不满意"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <div class="weui-cell" v-if="show">
        <div class="weui-cell__hd">
          <label class="weui-label" align="left">建议：</label>
        </div>
        <div class="weui-cell__bd">
          <input
            v-model="suggest"
            class="weui-input"
            type="text"
            placeholder="非必填"
          />
        </div>
      </div>
    </div>
    <div class="weui-cells__title">
      3.在您需要安保、前台人员的帮助时，是否得到了有效的帮助？
    </div>
    <div class="weui-cells weui-cells_radio">
      <label class="weui-cell weui-check__label" for="x31">
        <div class="weui-cell__bd">
          <p>是</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            class="weui-check"
            name="radio3"
            id="x31"
            value="是"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x32">
        <div class="weui-cell__bd">
          <p>否</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio3"
            class="weui-check"
            id="x32"
            value="否"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="x33">
        <div class="weui-cell__bd">
          <p>无需帮助</p>
        </div>
        <div class="weui-cell__ft">
          <input
            type="radio"
            name="radio3"
            class="weui-check"
            id="x33"
            value="无需帮助"
          />
          <span class="weui-icon-checked"></span>
        </div>
      </label>
    </div>
    <div class="weui-cells__title">
      4.基于以上提到的各方面，请您对本次来访体验进行评分
    </div>
    <div class="weui-cells weui-cells_radio">
      <label class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label" align="left" style="width=21px"
            >评分:
          </label>
        </div>
        <div class="weui-cell__bd">
          <ul class="StarsWrap">
        <li v-for="(i, index) in list" :key="index" @click="clickStars(index)">
          <img :src="xing > index ? stara : starb" />
        </li>
      </ul>
      <p>{{ rateScoreText }}</p>
        </div>
      </label>
    </div>
    <div class="weui-btn-area">
      <button
        class="weui-btn weui-btn_primary"
        @click="questionnaire()"
        style="background-color: #169bd5; color: #ffffff"
      >
        提交
      </button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from "../request/http"
import { Toast } from "we-vue"
export default {
  name: "evaluate",
  data() {
    return {
      sourceid: "",
      sourcetype: "",
      suggest: "",
      model: {},
      show: false,
      reason: "",
      rateScoreText: "",
      rateScoreDesc: [
        "1分",
        "2分",
        "3分",
        "4分",
        "5分"
      ],
      stara: "../../static/img/details/shoucang.png", // 亮星星
      list: [0, 1, 2, 3, 4],
      starb: "../../static/img/details/shouc.png", // 暗星星
      xing: 0
    }
  },
  created() {
    document.title = "鼎信通讯访客满意度调研"
  },
  mounted() {
    this.$set(this.model, "reason", "")
  },
  methods: {
    changeState() {
      var hasreason = this.reason
      if (hasreason) {
        var tesObjs = document.getElementsByName("radio1")
        // 获取选中的值
        for (var i = 0; i < tesObjs.length; i++) {
          if (tesObjs[i].checked === true) {
            tesObjs[i].checked = false
            break
          }
        }
      }
    },

    disContent() {
      var tesObj = document.getElementById("x25")
      if (tesObj.checked === true) {
        this.show = true
      } else {
        this.show = false
      }
    },
    clickStars(i) {
      this.rateScoreText = this.rateScoreDesc[i]
      this.xing = i + 1
      // console.log("点击了" + (i + 1) + "颗星")
    },
    holdReason() {
      var tesObjs = document.getElementsByName("radio1")
      // 获取选中的值
      var reasontemp = ""
      var hasreason = this.reason
      for (var i = 0; i < tesObjs.length; i++) {
        if (tesObjs[i].checked === true) {
          reasontemp = tesObjs[i].value
          break
        }
      }
      if (reasontemp) {
        if (hasreason) {
          reasontemp = reasontemp + ":" + hasreason
        }
      } else {
        if (hasreason) {
          reasontemp = hasreason
        }
      }
      this.$set(this.model, "reason", reasontemp)
    },
    holdContent() {
      var tesObjs = document.getElementsByName("radio2")
      // 获取选中的值
      for (var i = 0; i < tesObjs.length; i++) {
        if (tesObjs[i].checked === true) {
          this.$set(this.model, "content", tesObjs[i].value)
          break
        }
      }
    },
    holdHelp() {
      var tesObjs = document.getElementsByName("radio3")
      // 获取选中的值
      for (var i = 0; i < tesObjs.length; i++) {
        if (tesObjs[i].checked === true) {
          this.$set(this.model, "ishelp", tesObjs[i].value)
          break
        }
      }
    },
    holdStars() {
      this.$set(this.model, "stars", this.xing)
    },
    getUrlParams(names) {
      // 获取？后面的参数
      var urlSearch = location.search
      var urlValue = ""
      // 以？*&来拆分
      var params = urlSearch.split(/[?*&]/)
        for (var i = 0; i < params.length; i++) {
        // 如果url参数里包含传递过来names字段，则取=后面的部分
            if (params[i].indexOf(names) >= 0) {
                urlValue = params[i].split("=")[1]
                return urlValue
            }
        }
      return urlValue
    },
    questionnaire() {
      this.sourceid = this.getUrlParams("sourceid")
      this.sourcetype = this.getUrlParams("sourcetype")
      this.$set(this.model, "sourceid", this.sourceid)
      this.$set(this.model, "sourcetype", this.sourcetype)
      var loading = this.$weui.loading("处理中，请稍侯。")
      this.holdReason()
      this.holdContent()
      this.holdHelp()
      this.holdStars()
      if (this.suggest) {
        this.$set(this.model, "suggest", this.suggest)
      }
      postAction("/vtp/toaEnterParkApply/questionnaire", this.model)
        .then((res) => {
          if (res.data.success) {
            Toast.success("感谢您的配合")
            loading.hide()
            this.$router.push({
              name: 'index',
              params: {
              }
            })
          } else {
            loading.hide()
            if (res.data.message) {
              Toast.fail(res.data.message)
            } else {
              Toast.fail("提交失败")
            }
          }
        })
        .catch((err) => {
          loading.hide()
        })
    }
  }
}
</script>

<style scoped>
.StarsWrap {
  width: 100%;
  height: 0.2rem;
  margin: 0.1rem 0;
}
.StarsWrap li {
  float: left;
  margin-right: 0.1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Questionnaire.vue